import { render } from "./Account.form.component.vue?vue&type=template&id=b3b7fe64"
import script from "./Account.form.component.vue?vue&type=script&lang=js"
export * from "./Account.form.component.vue?vue&type=script&lang=js"

import "./Account.form.component.vue?vue&type=style&index=0&id=b3b7fe64&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QFooter,QBtn});
